<section [class]="merge('fw h-full', mainClass)">
  <!-- title -->
  <header class="fw__head">
    <h2 class="bk-heading fw__title" [id]="titleId">{{ title }}</h2>
    @if (icon) {
      <button
        type="button"
        class="bk-icon-btn fw__icon"
        [attr.aria-label]="iconLabel"
        (click)="iconClick.emit()"
      >
        <span class="bk-sym" aria-hidden="true">{{ isClose ? 'close' : icon }}</span>
      </button>
    }
  </header>

  <!-- form -->
  <div [class]="merge('containerClass h-fit', contentClass)">
    <ng-content></ng-content>
  </div>
</section>
